import { render } from "./Create.vue?vue&type=template&id=2ed56808&scoped=true"
import script from "./Create.vue?vue&type=script&setup=true&lang=js"
export * from "./Create.vue?vue&type=script&setup=true&lang=js"

import "./Create.vue?vue&type=style&index=0&id=2ed56808&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed56808"],['__file',"resources/js/Pages/ItemAssets/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ed56808"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ed56808', __exports__)) {
    console.log('reload')
    api.reload('2ed56808', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=2ed56808&scoped=true", () => {
    console.log('re-render')
    api.rerender('2ed56808', render)
  })

}


export default __exports__